import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableSortLabel: {
    color: theme.palette.grey[800]
  },
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 4fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    backgroundColor: theme.palette.background.paper,
    marginTop: 4,
    borderRadius: 12
  },
  tableHeadWithoutCreditor: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    backgroundColor: theme.palette.background.paper,
    marginTop: 4,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: theme.palette.text.secondary,
    padding: '0 0 0 12px',
    backgroundColor: theme.palette.background.paper,
    marginBottom: 4,
    marginTop: 4,
    borderRadius: 12,
    alignItems: 'center'
  },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '15fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 4fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'unset'
  },
  tableRowWithoutCreditor: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'unset'
  },
  tableRowSkeleton: {
    display: 'grid',
    gridTemplateColumns: '12fr 8fr 3fr',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    width: '100%',
    textAlign: 'unset',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '7fr 3fr'
    }
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    height: 60,
    alignItems: 'center',
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12
  },
  nameCell: {
    display: 'flex'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },

  active: {
    color: theme.palette.success.main
  },
  deactive: {
    color: theme.palette.error.main
  },
  iconWrapper: {
    display: 'flex', // Flexbox layout to center content
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    transform: 'rotate(90deg)', // Rotate the icon 90 degrees
    backgroundColor: 'white', // White background
    borderRadius: '50%', // Circular shape
    padding: theme.spacing(1), // Padding to control circle size
    width: '40px', // Set width for the circle
    height: '40px', // Set height for the circle
    marginLeft: -16
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    gap: 5
  },
  penaltyText: {
    color: theme.palette.error.main
  },
  rewardText: {
    color: theme.palette.success.main
  }
}))

export default useStyles
